import type { LucideIcon } from 'lucide-react';
import { tv } from 'tailwind-variants';

const badge = tv({
  base: 'inline-flex shrink-0 items-center justify-center',
  variants: {
    tone: {
      sidebar: 'bg-white/10 text-[var(--color-rail-sidebar-text)]',
      sidebarActive: 'bg-white/20 text-white',
      header: 'rounded-xl bg-[var(--color-an-primary)]/10 text-[var(--color-an-primary)]',
      group: 'rounded-md bg-white/10 text-[var(--color-rail-sidebar-muted)]',
      superGroup: 'rounded-md bg-[var(--color-rail-sidebar-active)]/25 text-[var(--color-rail-sidebar-text)]',
    },
    size: {
      sm: 'h-6 w-6 rounded-md',
      md: 'h-7 w-7 rounded-lg',
      lg: 'h-10 w-10 rounded-xl',
    },
  },
  defaultVariants: {
    tone: 'sidebar',
    size: 'md',
  },
});

const iconSize = tv({
  variants: {
    size: {
      sm: 'h-3 w-3',
      md: 'h-4 w-4',
      lg: 'h-5 w-5',
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

export type EnterpriseNavIconTone = 'sidebar' | 'sidebarActive' | 'header' | 'group' | 'superGroup';
export type EnterpriseNavIconSize = 'sm' | 'md' | 'lg';

export interface EnterpriseNavIconBadgeProps {
  readonly icon: LucideIcon;
  readonly tone?: EnterpriseNavIconTone;
  readonly size?: EnterpriseNavIconSize;
  readonly className?: string;
  readonly 'data-testid'?: string;
}

export function EnterpriseNavIconBadge({
  icon: Icon,
  tone = 'sidebar',
  size = 'md',
  className,
  'data-testid': dataTestId,
}: EnterpriseNavIconBadgeProps): JSX.Element {
  return (
    <span className={badge({ tone, size, className })} data-testid={dataTestId}>
      <Icon className={[iconSize({ size }), 'stroke-[1.75]'].join(' ')} aria-hidden />
    </span>
  );
}
